module.exports = __webpack_public_path__ + "static/media/BuhlerSMA-203.c2dff49a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/stores/presets/photos/BuhlerSMA-203.jpg
// module id = 152
// module chunks = 0